import { useMemo, useState } from 'react';

import { Service } from '@app-types/service.type';

import styles from './service-item.module.scss';
import { buildServiceMetadata } from './utils';
import { ServiceMetadata } from './service-metadata';
import { ServiceCardHeader } from './card-header';
import { ServiceCardDetails } from './card-details';

type Props = {
    service: Service;
    onCreatePlan: (serviceId: number) => void;
    onEdit: (id: number) => void;
};

const ServiceItem = ({ service, onCreatePlan, onEdit }: Props) => {
    const [expanded, setExpanded] = useState(false);

    const serviceMetadata = useMemo(() => {
        return buildServiceMetadata(service);
    }, [service]);

    return (
        <div className={styles.item}>
            <div className={styles.card}>
                <ServiceCardHeader
                    service={service}
                    expanded={expanded}
                    onEdit={onEdit}
                    onExpand={() => setExpanded(!expanded)}
                />
                <span className={styles.description}>
                    {service.description}
                </span>
                <ServiceMetadata metadata={serviceMetadata} />
            </div>
            {expanded && (
                <ServiceCardDetails
                    service={service}
                    onCreatePlan={onCreatePlan}
                />
            )}
        </div>
    );
};

export { ServiceItem };
